import { render } from "./Email.vue?vue&type=template&id=75904787"
import script from "./Email.vue?vue&type=script&setup=true&lang=js"
export * from "./Email.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Auth/Passwords/Email.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75904787"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75904787', __exports__)) {
    api.reload('75904787', __exports__)
  }
  
  module.hot.accept("./Email.vue?vue&type=template&id=75904787", () => {
    api.rerender('75904787', render)
  })

}


export default __exports__